export const profilePlatformTypes = {
    uplay: "uplay",
    amazonstream: "amazonstream",
};

export interface ProfileEntity {
    idOnPlatform: string;
    nameOnPlatform: string;
    platformType: string;
    profileId: string;
    userId: string;
}